import { render, staticRenderFns } from "./settingKB.vue?vue&type=template&id=53cbffd6"
import script from "./settingKB.vue?vue&type=script&lang=js"
export * from "./settingKB.vue?vue&type=script&lang=js"
import style0 from "./settingKB.vue?vue&type=style&index=0&id=53cbffd6&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53cbffd6')) {
      api.createRecord('53cbffd6', component.options)
    } else {
      api.reload('53cbffd6', component.options)
    }
    module.hot.accept("./settingKB.vue?vue&type=template&id=53cbffd6", function () {
      api.rerender('53cbffd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/components/settingKB.vue"
export default component.exports